<template>
  <div class="level-fullscreen">
    <div
      v-if="showElements"
      style="position: relative; width: 100%; text-align: center"
    >
      <h1 id="level-text">Level {{ level + 1 }}</h1>

      <div style="position: absolute; width: 100%">
        <a @click="done" id="done-button" class="done-button throb">Start</a>
      </div>
    </div>
    <!--<a @click="done" id="done-button" class="done-button">Start</a>-->
    <div
      v-if="showAnim"
      class="lottie-anim-container"
      id="level-start-anim"
    ></div>
  </div>
</template>

<script>
import * as unlockAnimGreen from '@/assets/zone_unlock_green.json'

import lottie from 'lottie-web'
import gsap from 'gsap'

export default {
  name: 'LevelStart',
  data() {
    return {
      showElements: false,
      showAnim: false,
    }
  },
  mounted() {
    this.showElements = false
    this.showAnim = false
  },
  computed: {
    levelStartAnimKey() {
      return this.$store.getters.levelStartAnimKey
    },
    level() {
      return this.$store.getters.level
    },
  },
  methods: {
    done() {
      this.$store.commit('SET_SHOW_LEVEL_START_SCREEN', false)
    },
    doAnim() {
      this.showAnim = true
      this.showElements = true

      this.$nextTick(() => {
        const anim = lottie.loadAnimation({
          container: document.getElementById('level-start-anim'),
          animationData: unlockAnimGreen.default,
          renderer: 'svg',
          autoplay: false,
          loop: false,
        })

        console.log('animation duration: ', anim.getDuration(false))

        anim.onComplete = () => {
          anim.destroy()
          this.showAnim = false
        }
        setTimeout(() => {
          anim.goToAndPlay(0)
        }, 500)

        gsap.from(document.getElementById('level-text'), {
          delay: 1,
          opacity: 0,
          duration: 0.5,
        })

        gsap.from(document.getElementById('done-button'), {
          delay: 2.5,
          opacity: 0,
          y: 15,
          duration: 0.5,
        })
      })
    },
  },
  watch: {
    levelStartAnimKey() {
      this.doAnim()
    },
  },
}
</script>

<style scoped>
.level-fullscreen {
  position: absolute;
  font-family: 'Montserrat', sans-serif;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  /*background-color: rgba(3, 28, 33, 0.8);*/
  background-color: #002228;
  color: #cdf4dd;
  z-index: 99;
}

.lottie-anim-container {
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
}

.done-button {
  max-width: 10em;
  width: 90%;
  display: inline-block;
  padding: 1em;
  text-align: center;
  border: 1px solid #cdf4dd;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.5s ease, color 0.5s ease;
}

@media (hover: hover) {
  .done-button:hover {
    background-color: rgba(204, 244, 221, 0.1);
  }
}

.done-button.throb {
  animation-name: button-throb-animation;
  animation-duration: 0.75s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  transform-origin: center;
}

@keyframes button-throb-animation {
  from {
    background-color: transparent;
  }
  to {
    background-color: rgba(224, 168, 0, 0.3);
  }
}
</style>
